import {POSTALCODE_VALIDATE_REQ} from "./postalCodeType";

const initialState = {
    postalCodeResp: {},
    statusCode: Number,
    responseMsg: "",
    exceptionMessage: "",
}

const postalCodeReducer = (state = initialState, action) => {

    switch (action.type) {
        case POSTALCODE_VALIDATE_REQ:
            return {
                ...state,
                postalCodeResp: action.payload.data,
                statusCode: action.payload.statusCode,
                responseMsg: action.payload.responseMsg,
                exceptionMessage: action.payload.exceptionMessage
            }
        default:
            return state;
    }
}

export default postalCodeReducer
